import { Modal } from '@redislabsdev/redis-ui-components';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import AppAuthFactorForm from './components/AppAuthFactorForm/AppAuthFactorForm';
import SmsFactorForm from './components/SmsFactorForm/SmsFactorForm';
import useLogOut from '../../../../hooks/useLogOut';
import { mfaPayloadSelector } from '../../../../store/auth/auth.selectors';

type MfaModalTypes = 'smsFactor' | 'totpFactor';

const MfaLoginModal = () => {
  const { totpFactorAvailable } = useSelector(mfaPayloadSelector);
  const [modalToDisplay, setModalToDisplay] = useState<MfaModalTypes>(
    totpFactorAvailable ? 'totpFactor' : 'smsFactor'
  );

  const { performLogout } = useLogOut();
  const switchToTotFactor = () => setModalToDisplay('totpFactor');
  const switchToSmsFactor = () => setModalToDisplay('smsFactor');

  return (
    <Modal.Compose open>
      <Modal.Content.Compose>
        <Modal.Content.Close
          onClick={() => {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            performLogout();
          }}
        />
        {modalToDisplay === 'smsFactor' ? (
          <SmsFactorForm switchToAuthAppModal={switchToTotFactor} />
        ) : (
          <AppAuthFactorForm switchToSmsModal={switchToSmsFactor} />
        )}
      </Modal.Content.Compose>
    </Modal.Compose>
  );
};

export default MfaLoginModal;
